import { cn } from '@/shared/utils/cn'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: React.ReactNode
  className?: string
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <header
      className={cn(
        'flex items-center justify-between border-b border-ue-border-medium px-6 py-4',
        className
      )}
    >
      <div>
        <h1 className="text-lg font-semibold text-ue-text-primary">{title}</h1>
        {description && (
          <p className="mt-0.5 text-sm text-ue-text-secondary">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  )
}
